import React from "react";

type GridBox = {
  left: number | string;
  right: number | string;
  top: number | string;
  bottom: number | string;
};

const DEFAULT_TOP_GRID: GridBox = {
  left: 44,
  right: 44,
  top: 38,
  bottom: "40%",
};

const DEFAULT_BOTTOM_GRID: GridBox = {
  left: 44,
  right: 44,
  top: "70%",
  bottom: 34,
};

const resolveOffset = (value: number | string, total: number) => {
  if (typeof value === "number") {
    return value;
  }

  if (typeof value === "string" && value.endsWith("%")) {
    return (parseFloat(value) / 100) * total;
  }

  return Number(value) || 0;
};

const getRectFromGrid = (grid: GridBox, width: number, height: number) => {
  const left = resolveOffset(grid.left, width);
  const right = resolveOffset(grid.right, width);
  const top = resolveOffset(grid.top, height);
  const bottom = resolveOffset(grid.bottom, height);

  return {
    left,
    top,
    width: Math.max(0, width - left - right),
    height: Math.max(0, height - top - bottom),
  };
};

const createPanelStyle = (
  rect: ReturnType<typeof getRectFromGrid>,
  containerWidth: number,
  options?: {
    rightGapRatio?: number;
    topGapRatio?: number;
    extraLeftShift?: number;
  }
): React.CSSProperties => {
  const rightGapRatio = options?.rightGapRatio ?? 0.02;
  const topGapRatio = options?.topGapRatio ?? 0.03;
  const extraLeftShift = options?.extraLeftShift ?? 0;
  const rightGap = rect.width * rightGapRatio;
  const topGap = rect.height * topGapRatio;
  const right = Math.max(
    0,
    containerWidth - (rect.left + rect.width) + rightGap + extraLeftShift
  );

  return {
    top: rect.top + topGap,
    right,
  };
};

export const getPerformanceOverlayLayout = (
  containerWidth: number,
  containerHeight: number
) => {
  const topRect = getRectFromGrid(DEFAULT_TOP_GRID, containerWidth, containerHeight);
  const bottomRect = getRectFromGrid(DEFAULT_BOTTOM_GRID, containerWidth, containerHeight);

  return {
    topPanelStyle: createPanelStyle(topRect, containerWidth, {
      rightGapRatio: 0.01,
      topGapRatio: 0.01,
      extraLeftShift: 44,
    }),
    bottomPanelStyle: createPanelStyle(bottomRect, containerWidth, {
      rightGapRatio: 0.01,
      topGapRatio: 0.01,
      extraLeftShift: 44,
    }),
  };
};
